import React from "react";
import { Smartphone, Home, Sprout, Sparkles } from "lucide-react";

const ICON_MAP = {
  smartphone: Smartphone,
  mobile: Smartphone,
  phone: Smartphone,
  home: Home,
  sprout: Sprout,
  growth: Sprout,
  zen: Sprout,
};

const FALLBACK_ICONS = [Smartphone, Home, Sprout];

/**
 * Section 03 — three cards (or however many configured) showing where Aris
 * fits into the user's life. Each card has an icon tile + title + subtitle.
 */
const WhereItFits = ({ section, number = "03" }) => {
  if (!section) return null;
  const { title = "Where it fits", description, cards = [] } = section;

  if (cards.length === 0 && !description) return null;

  return (
    <div className="corp-section-card">
      <div className="flex items-center gap-3">
        <span className="corp-section-num">{number}</span>
        <h2 className="corp-section-title">{title}</h2>
      </div>
      {description && <p className="corp-section-desc">{description}</p>}
      {cards.length > 0 && (
        <div className="flex flex-col md:flex-row gap-3">
          {cards.map((card, idx) => {
            const Icon =
              (card.icon && ICON_MAP[String(card.icon).toLowerCase()]) ||
              FALLBACK_ICONS[idx % FALLBACK_ICONS.length] ||
              Sparkles;
            return (
              <div key={idx} className="corp-fit-card">
                <span className="corp-icon-tile corp-icon-tile--neutral">
                  <Icon size={20} />
                </span>
                <div className="flex flex-col gap-2 min-w-0">
                  <span className="text-sm font-semibold text-[#444]">
                    {card.title}
                  </span>
                  {card.subtitle && (
                    <span className="text-xs text-[#7e7f83] truncate">
                      {card.subtitle}
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default WhereItFits;
